module.exports = __webpack_public_path__ + "img/edit_location_alt.0502a68c.svg";